<template>
  <div>
    <div class="sus">
      <div class="sus-i">
        <img src="../assets/img/deft.png" alt="" />
      </div>
      <div class="sus-m">
        <p>支付失败</p>
      </div>

    </div>
    <button class="btn btn-green" @click="link('/pay')">重新支付</button>
  </div>
</template>
<script>
export default{


 
 
methods: {
    link(url) {
      this.$router.push(url)
    }
    }
}
</script>

<style scoped>
.sus {
  width: 680px;
  height: 400px;
  background: #fff;
  margin: 200px auto;
}

.sus-i {
  width: 680px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sus-i img {
  width: 134px;
  height: 134px;
}

.sus-m {
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #333333;
  font-size: 36px;
}

.sus-m p {
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 500;
}

.countCircle {
  height: 100px;
  text-align: center;
  line-height: 100px;  
}




</style>


// WEBPACK FOOTER //
// src/pages/deft.vue